/**
*
* RedAgendaStacked
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';


import setLanguageContent from 'helpers/setLanguageContent';
import cloneDeep from 'helpers/cloneDeep';

import Wrapper from 'components/Templates/dynamics/Wrapper';
import TemplateFilterSwitch from 'components/TemplateFilterSwitch';


import {
  sortByDate,
} from './helpers';

import RedAgendaStackedPresentation from './RedAgendaStackedPresentation';
import RedAgendaPresentation from './RedAgendaPresentation';

import defaultTextValues from './defaultTextValues';


class RedAgendaStacked extends React.Component {

  constructor() {
    super();

    this._isMounted = false;



    this.handleShowPresentation = this.handleShowPresentation.bind(this);
    this.handleDropdownDaySelection = this.handleDropdownDaySelection.bind(this);
    this.setSelectedFilter = this.setSelectedFilter.bind(this);
    this.handleIsTagActive = this.handleIsTagActive.bind(this);

    this.state = {
      presentationData: '',
      chosenDay: 0,
      availableTags: [],
      selectedTagsFilter: [],
    };
  }




  handleShowPresentation(payload) {
    this.setState({
      presentationData: payload,
    });
  }

  handleDropdownDaySelection(day) {

    this.setState({
      chosenDay: day
    }, () => {

      const {
        commonProps,
        agendaData,
      } = this.props;

      const {
        isEditor,
        isPreview,
        frameRef
      } = commonProps;

      if (!agendaData) return '';

      const {
        agenda
      } = agendaData;

      const agendaSorted = agenda.sort(function (a, b) {
        return a.dayDate - b.dayDate;
      });

      for (let index = 0; index < agendaSorted.length; index++) {
        const thisAgendaElement = agendaSorted[index];
        if (this.state.chosenDay === index && this[thisAgendaElement.agendaId] && this[thisAgendaElement.agendaId].current) {


          const element = this[thisAgendaElement.agendaId].current;
          const elementPosition = element.getBoundingClientRect().top;


          const getParentNode = isEditor ? document.querySelector(frameRef).contentWindow : window;

          if (getParentNode) {
            const getFrame = frameRef && document.querySelector(frameRef) ? document.querySelector(frameRef).contentWindow : window;

            const offsetPosition = elementPosition + getParentNode.scrollY - (window.innerHeight / 4);

            getFrame.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });

          }

          break;
        }

      }



    });
  }


  setSelectedFilter(filter, type) {
    const newFilters = this.state[`selected${type}Filter`];

    if (newFilters.includes(filter)) {
      const index = newFilters.indexOf(filter);
      newFilters.splice(index, 1);
      return this.setState({
        [`selected${type}Filter`]: newFilters
      });
    }

    newFilters.push(filter);
    return this.setState({
      [`selected${type}Filter`]: newFilters
    });

  }

  handleIsTagActive(tagId, remove) {

    const {
      selectedTagsFilter
    } = this.state



    if (selectedTagsFilter.includes(tagId) || remove) {
      this.setState(prevState => {
        let newSelectedTags = cloneDeep(prevState.selectedTagsFilter);
        newSelectedTags = newSelectedTags.filter(tag => tag !== tagId);

        return {
          selectedTagsFilter: newSelectedTags
        };
      })
    }

    if (!selectedTagsFilter.includes(tagId) && !remove) {
      this.setState(prevState => {
        const newSelectedTags = cloneDeep(prevState.selectedTagsFilter);
        newSelectedTags.push(tagId)

        return {
          selectedTagsFilter: newSelectedTags
        };
      })
    }

  }

  componentDidMount() {

    this._isMounted = true;



    const {
      commonData,
      viewRef
    } = this.props;

    const {
      componentPayload
    } = commonData;

    const {
      availableTags
    } = componentPayload;

    this.setState({
      availableTags: availableTags
    });

    if (this.props.viewRef && document.querySelector(viewRef) && !this.state.hasScroll) {
      this.setState({
        hasScroll: true
      });
    }


  }

  componentWillUnmount() {
    this._isMounted = false;
  }



  render() {

    const {
      commonData,
      commonProps,
      agendaData,
      companies,
    } = this.props;

    const {
      timezone,
      language,
      isEditor,
      isPreview,
      frameRef,
    } = commonProps;

    const {
      customStyles,
      sectionId,
      componentPayload
    } = commonData;

    const {
      enableFilters
    } = componentPayload;

    if (!agendaData) return '';

    const {
      presentations,
      agenda
    } = agendaData;

    const {
      chosenDay,
      presentationData,
      availableTags,
      selectedTagsFilter,
    } = this.state;
    
    const filteredAvailableTags = availableTags ? availableTags.filter(tag => presentations?.reduce((acc, presentation) => acc = presentation?.tags ? [...acc, ...presentation.tags] : [...acc], []).includes(tag.tagId)) : '';

    const selectedFilters = {
      Tags: selectedTagsFilter.length ? selectedTagsFilter : []
    };

    const availableFilters = {
      Tags: filteredAvailableTags || []
    };

    const activeFiltersNumber = Object.keys(selectedFilters).reduce((acc, key) => acc + selectedFilters[key].length, 0);


    const utcHoursOffset = moment().tz(timezone).utcOffset() / 60;
    const offsetString = `GMT ${utcHoursOffset > -1 ? '+' : ''}${utcHoursOffset}`;

    const agendaSorted = agenda.sort(function (a, b) {
      return a.dayDate - b.dayDate;
    });

    const dayTabs = agendaSorted ? agendaSorted.map((thisAgendaElement, b) => {
      const handleTabSwitch = () => {

        this.setState({
          chosenDay: b
        }, () => {
          setTimeout(() => {
            if (this[thisAgendaElement.agendaId] && this[thisAgendaElement.agendaId].current) {


              const element = this[thisAgendaElement.agendaId].current;
              const elementPosition = element.getBoundingClientRect().top;


              const getParentNode = isEditor ? document.querySelector(frameRef).contentWindow : window;

              if (getParentNode) {
                const getFrame = frameRef && document.querySelector(frameRef) ? document.querySelector(frameRef).contentWindow : window;

                const offsetPosition = elementPosition + getParentNode.scrollY - (window.innerHeight / 4);

                getFrame.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });

              }
            }


          }, 300);
        });

      };

      return (
        <Wrapper
          {...commonProps}
          key={`RedAgendaStacked-dayTab-${b}`}

          typeOfStyle={this.state.chosenDay === b ? 'dayTabActive' : 'dayTab'}
          handleClick={handleTabSwitch}
          editorData={
            {
              editorType: this.state.chosenDay === b ? 'dayTabActive' : 'dayTab',
              ...commonData
            }
          }
          active={this.state.chosenDay === b} // ? Not sure how to handle state of this tab
        >
          {thisAgendaElement && thisAgendaElement.title ? setLanguageContent(thisAgendaElement, 'title', language) : thisAgendaElement.dayDate ? moment(thisAgendaElement.dayDate).tz(timezone).format('MMMM DD') : ''}
        </Wrapper>
      );

    }) : '';

    const dayDropdownOptions = agendaSorted ? agendaSorted.map((option, b) => {

      return {
        title: option && option.title ? setLanguageContent(option, 'title', language) : option.dayDate ? moment(option.dayDate).tz(timezone).format('Do MMMM') : '',
        value: b
      }
    }) : '';



    const thisAgenda = agendaSorted[chosenDay];
    const allPresentations = {};
    const allPresentationsNoTrack = [];


    const tracks = thisAgenda && thisAgenda.tracks ? thisAgenda.tracks.map((track, i) => {

      const thisTrack = cloneDeep(track);
      const presentationsTrackCount = {};

      if (!thisTrack.presentations) return thisTrack;

      const trackTitle = setLanguageContent(thisTrack, 'title', language);

      const mapPresentations = thisTrack.presentations.map((trackPresentation) => {
        let thisPresentationData;
        if (presentations && presentations.length) {
          for (let c = 0; c < presentations.length; c++) {
            if (presentations[c].presentationId === trackPresentation.presentationId) {

              if (presentations[c].isHidden) return;

              const thisPresentation = cloneDeep(presentations[c]);

              const start = moment(thisPresentation.dateFrom).tz(timezone);
              const end = moment(thisPresentation.dateTo).tz(timezone);
              let diff = end.diff(start);
              diff = moment.utc(diff);
              diff = parseInt((diff.format('HH') * 60)) + parseInt(diff.format('mm'));
              let diffMinutes = diff;

              const thisPresentationHour = start.format('HH');
              let thisPresentationMinutes = start.format('mm');

              const thisPresentationHourEnd = end.format('HH');
              const thisPresentationMinutesEnd = end.format('mm');

              if (diff == 0) diffMinutes = thisPresentationMinutesEnd - thisPresentationMinutes;

              thisPresentation.startHour = thisPresentationHour;
              thisPresentation.startMinutes = thisPresentationMinutes;
              thisPresentation.endHour = thisPresentationHourEnd;
              thisPresentation.endMinutes = thisPresentationMinutesEnd;
              thisPresentation.diff = diff;
              thisPresentation.diffMinutes = diffMinutes;

              thisPresentationMinutes = Number(thisPresentationMinutes);

              thisPresentationMinutes = thisPresentationMinutes >= 30 ? '30' : '00';

              const trackCountKey = thisPresentationHour + thisPresentationMinutes;

              presentationsTrackCount[trackCountKey] = presentationsTrackCount[trackCountKey] ? presentationsTrackCount[trackCountKey] + 1 : 1;
              thisPresentation.rowNumber = presentationsTrackCount[trackCountKey];
              thisPresentation.trackKey = trackCountKey;

              thisPresentation.trackTitle = trackTitle;

              if (!allPresentations[thisAgenda.agendaId]) allPresentations[thisAgenda.agendaId] = [];
              allPresentations[thisAgenda.agendaId].push(thisPresentation);
              allPresentationsNoTrack.push(thisPresentation);

              thisPresentationData = thisPresentation;
              break;
            }
          }
        }
        return thisPresentationData;
      });

      thisTrack.trackCount = presentationsTrackCount;

      const sortPresentations = mapPresentations.sort(sortByDate);
      thisTrack.presentations = sortPresentations;

      return thisTrack;
    }) : '';





    const allSortedDayPresentations = {};
    for (const [thisAgendaKey, thisAgenda] of Object.entries(allPresentations)) {
      allSortedDayPresentations[thisAgendaKey] = thisAgenda.sort(sortByDate);
    }

    const allPresentationsNoTrackSort = allPresentationsNoTrack.sort(sortByDate);

    const agendaContent = [];

    for (const [thisAgendaKey, thisAgenda] of Object.entries(allSortedDayPresentations)) {
      if (thisAgenda && thisAgenda.length > 0) {

        const filteredPresentations = selectedTagsFilter.length && thisAgenda ? thisAgenda.sort(sortByDate).filter(presentation => {


          let isFiltered = false;

          if (!presentation) return isFiltered;

          for (const filterKey in selectedFilters) {

            if (selectedFilters[filterKey].length) {

              const lowercaseKey = filterKey.toLowerCase();
              if (Array.isArray(presentation[lowercaseKey])) {
                const intersection = presentation[lowercaseKey].filter(value => selectedFilters[filterKey].includes(value));

                if (!intersection.length) {
                  isFiltered = false;
                  break;
                }
                isFiltered = true;
              }
            }
          }

          return isFiltered;

        }) : thisAgenda ? thisAgenda.sort(sortByDate) : null;



        const presentationsContent = filteredPresentations.map(presentation => {

          if (!presentation) return;

          const { presentationId } = presentation;

          return (
            <RedAgendaStackedPresentation
              {...this.props}
              presentation={presentation}
              handleShowPresentation={this.handleShowPresentation}
              key={`RedAgendaStackedPresentation-${presentationId}`}
              companies={companies}
              availableTags={filteredAvailableTags}
              handleIsTagActive={this.handleIsTagActive}
              enableFilters={enableFilters}
            />
          );

        });

        let getAgendaDay = agendaSorted.map((thisDay) => {
          if (thisAgendaKey === thisDay.agendaId) return thisDay;
        }).filter((a) => a);
        if (getAgendaDay && getAgendaDay[0]) getAgendaDay = getAgendaDay[0];

        if (!this[getAgendaDay.agendaId]) this[getAgendaDay.agendaId] = React.createRef();

        agendaContent.push(
          <Wrapper
            {...commonProps}

            typeOfStyle={'dayContainer'}
            key={`RedAgendaStackedDayContainer-${getAgendaDay.agendaId}`}
            innerRef={this[getAgendaDay.agendaId]}
            editorData={
              {
                editorType: 'dayContainer',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}

              typeOfStyle={'dayTitle'}
              editorData={
                {
                  editorType: 'dayTitle',
                  ...commonData
                }
              }
            >
              {getAgendaDay && getAgendaDay.title ? setLanguageContent(getAgendaDay, 'title', language) : getAgendaDay && getAgendaDay.dayDate ? moment(getAgendaDay.dayDate).tz(timezone).format('MMMM DD') : ''}
            </Wrapper>
            <Wrapper
              {...commonProps}

              typeOfStyle={'dayAllTracksContainer'}
              editorData={
                {
                  editorType: 'dayAllTracksContainer',
                  ...commonData
                }
              }
            >
              {presentationsContent}
            </Wrapper>
          </Wrapper>
        );

      }
    }




    const singlePresentationContent = presentationData ? (
      <RedAgendaPresentation
        {...this.props}
        allSortedDayPresentations={allPresentationsNoTrackSort}
        presentation={presentationData}
        isSingle={true}
        handleShowPresentation={this.handleShowPresentation}
        offsetString={offsetString}
        agendaSorted={agendaSorted}
        availableTags={filteredAvailableTags}
        handleIsTagActive={this.handleIsTagActive}
        enableFilters={enableFilters}
      />
    ) : '';

    const dayDropdown = (
      <Wrapper
        {...commonProps}

        typeOfStyle={'dayDropdown'}
        type={'select'}
        selectValue={agendaSorted[chosenDay] && agendaSorted[chosenDay].title ? setLanguageContent(agendaSorted[chosenDay], 'title', language) : agendaSorted[chosenDay].dayDate ? moment(agendaSorted[chosenDay].dayDate).tz(timezone).format('Do MMMM') : ''}
        selectData={{
          options: dayDropdownOptions,
          dropdownItemStyles: { fontSize: '1.8rem', 'margin-bottom': '0' },
          selectedStyles: { fontSize: '1.8rem', 'margin-bottom': '0' }
        }}
        handleSelectChange={this.handleDropdownDaySelection}
        editorData={
          {
            editorType: 'dayDropdown',
            ...commonData
          }
        }
      />
    );

    return (
      <Wrapper
        {...commonProps}
        key={`RedAgendaStacked-wrapper-${sectionId}-${chosenDay}`}
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >

        <Wrapper
          {...commonProps}

          typeOfStyle={'sectionTitle'}
          defaultValues={defaultTextValues}
          type={'text'}
          editorData={
            {
              editorType: 'sectionTitle',
              ...commonData
            }
          }
        />
        <Wrapper
          {...commonProps}

          typeOfStyle={'mainInnerWrapper'}
          editorData={
            {
              editorType: 'mainInnerWrapper',
              ...commonData
            }
          }
        >
          <TemplateFilterSwitch
            activeFiltersNumber={activeFiltersNumber}
            handleFilterClick={this.setSelectedFilter}
            availableFilters={availableFilters}
            selectedFilters={selectedFilters}
            enableFilters={enableFilters}
            commonProps={commonProps}
            typeOfStyle={'filterTagItem'}
            customStyles={customStyles}
          />
          <Wrapper
            {...commonProps}

            typeOfStyle={'topOptionsWrapper'}
            editorData={
              {
                editorType: 'topOptionsWrapper',
                ...commonData
              }
            }
          >
            {dayTabs}
            {dayDropdown}
          </Wrapper>
          <Wrapper
            {...commonProps}

            typeOfStyle={'timeAndContentWrapper'}
            editorData={
              {
                editorType: 'timeAndContentWrapper',
                ...commonData
              }
            }
          >
            {agendaContent && agendaContent.length ? (
              <Wrapper
                {...commonProps}

                typeOfStyle={'contentAgenda'}
                editorData={
                  {
                    editorType: 'contentAgenda',
                    ...commonData
                  }
                }
              >
                {agendaContent}
              </Wrapper>
            ) : (
              <Wrapper
                {...commonProps}

                typeOfStyle={'missingAgenda'}
                editorData={
                  {
                    editorType: 'missingAgenda',
                    ...commonData
                  }
                }
              >
                Agenda coming soon...
              </Wrapper>
            )}
          </Wrapper>

        </Wrapper>
        {singlePresentationContent}
      </Wrapper>
    );
  }
}

RedAgendaStacked.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  agendaData: PropTypes.object,
  isEditor: PropTypes.bool,
  companies: PropTypes.array
};

export default RedAgendaStacked;
